import main from '../main.js'
var axios = require('axios')
const url = 'api'
const prefixLocalisation = process.env.version + '/product-localisation/'
const prefixfe = process.env.version + '/product-hut-fe/'
const prefixfev2 = process.env.version2 + '/product-hut-fe/'
/**
 * Get list outLets for take-away or a outlet for delivery
 * */
axios.checkLocation = function (data, success, callBackError) {
  axios.options.notify = false
  this.get(prefixfe + 'localizations', {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}
/**
 * Get list outLets by postal code
 * */
axios.getNextLevelData = function (data, success, callBackError) {
  axios.options.flag = false
  axios.options.notify = false
  this.get(prefixLocalisation + 'search', {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

/**
 * Checking Outlet is available
 * */
axios.checkOutletAvailable = function (data, success, callBackError) {
  axios.options.flag = false
  axios.options.notify = false
  this.post(prefixfe + 'outlets/available', data).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

/**https://api.phdvasia.com/v1/product-hut-fe/opening_hours_summary/5?order_type=C
 * Get outlet's opening hours
 * */
axios.getOutletOpeningHours = function (data, success, callBackError) {
  axios.options.notify = false
  if (data.hideFlag) {
    axios.options.flag = false
    delete data['hideFlag']
  }
  this.get(prefixfe + 'opening_hours_summary/' + data.outletId, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

/**
 * Get outlets by address code or zipcode or outletid
 * */
axios.getOutletByAddressCode = function (data, success, callBackError) {
  axios.options.notify = false
  this.get(prefixfe + 'mappings', {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

/**
 * Get outlets by outlet code
 * */
axios.getOutLetByCode = function (data, success, callBackError) {
  axios.options.notify = false
  this.get(prefixfe + 'outlets/detail/' + data.code, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 404 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.getAddressByAddressCode = function (data, success, callBackError) {
  axios.options.notify = false
  this.get(prefixfe + 'address/', {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 404 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.checkAddressCode = function (data, success, callBackError) {
  axios.options.flag = false
  axios.options.notify = false
  this.post(prefixfev2 + 'outlets/check-address-code', data).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}
export default axios



// WEBPACK FOOTER //
// ./src/api/Outlet.js